var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGIconEuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600-120q-118 0-210-67T260-360H160q-17 0-28.5-11.5T120-400q0-17 11.5-28.5T160-440h82q-2-11-2-20v-40q0-9 2-20h-82q-17 0-28.5-11.5T120-560q0-17 11.5-28.5T160-600h100q38-106 130-173t210-67q57 0 107 16.5t94 45.5q17 11 17.5 31T805-713q-14 14-35 16.5t-39-8.5q-29-17-62.5-26t-68.5-9q-75 0-136.5 38.5T370-600h190q17 0 28.5 11.5T600-560q0 17-11.5 28.5T560-520H344q-2 11-3 20t-1 20q0 11 1 20t3 20h216q17 0 28.5 11.5T600-400q0 17-11.5 28.5T560-360H370q32 63 93.5 101.5T600-220q35 0 68.5-8.5T731-254q18-11 39-9t35 16q14 14 13.5 34T801-182q-44 29-94 45.5T600-120Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGIconEuro);
export default __webpack_public_path__ + "static/media/g_icon_euro.d5ddf65b9602dbb0de0beaaaa15adbfd.svg";
export { ForwardRef as ReactComponent };